import React, { useState, useEffect } from 'react';
import {
	withMobileDialog,
	Dialog,
	DialogTitle,
	DialogContent,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
	Paper,
	IconButton,
	Tooltip
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
	root: {
		width: '100%',
		marginTop: theme.spacing(5),
		overflowX: 'auto'
	},
	table: {
		minWidth: 700
	},
	fab: {
		margin: theme.spacing(2)
	},
	absolute: {
		position: 'absolute',
		bottom: theme.spacing(2),
		right: theme.spacing(5)
	},
	progress: {
		margin: '0px',
		color: '#707070'
	}
});

function desc(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

const ModalBenefitsList = (props) => {
	const {
		open,
		handleClose,
		customers,
		fullScreen,
		classes,
		showMoreInformation
	} = props;

	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');

	const statusMessage = (status) => {
		if (status === 'pending') {
			return 'Pendiente';
		} else if (status === 'succeeded') {
			return 'Exitoso';
		} else if (status === 'denied') {
			return 'Denegado';
		} else {
			return '';
		}
	};

	const frecuency = (param) => {
		if (param === 'month') {
			return 'Mensual';
		} else if (param === 'year') {
			return 'Anual';
		} else if (param === 'week') {
			return 'Semanal';
		} else if (param === 'day') {
			return 'Diario';
		} else if (param === 'bimonthly') {
			return 'Bimestral';
		} else if (param === 'quarterly') {
			return 'Trimestral';
		} else if (param === 'semiannual') {
			return 'Semestral';
		} else {
			return '';
		}
	};

	return (
		<Dialog
			open={open || false}
			disableBackdropClick={true}
			disableEscapeKeyDown={true}
			fullScreen={fullScreen}
			maxWidth="lg"
		>
			<DialogTitle>
				<div className="flex justify-between">
					<span className="font-bold text-gray-800">Beneficiarios</span>
					<button
						className="secondary-button-nav min-w-small"
						onClick={() => handleClose(false)}
					>
						Cerrar
					</button>
				</div>
			</DialogTitle>

			<DialogContent>
				<div className="w-full flex flex-wrap">
					<Paper className={classes.root}>
						<Table className={classes.table}>
							<TableHead>
								<TableRow className="table-header">
									<TableCell align="left">
										<TableSortLabel
											active={orderBy === 'fisrt_name'}
											direction={order}
										>
											Nombre y Apellido
										</TableSortLabel>
									</TableCell>

									{/*<TableCell
                    sortDirection={orderBy === 'email' ? order : false}
                    align='left'
                  >
                    <TableSortLabel
                      active={orderBy === 'email'}
                      direction={order}
                    >
                      Email
				            </TableSortLabel>
                  </TableCell>

                  <TableCell
                    sortDirection={orderBy === 'kinship' ? order : false}
                    align='left'
                  >
                    <TableSortLabel
                      active={orderBy === 'kinship'}
                      direction={order}
                    >
                      Parentesco
				           </TableSortLabel>
                  </TableCell>*/}

									<TableCell
										sortDirection={
											orderBy === 'product_id.name' ? order : false
										}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'product_id.name'}
											direction={order}
										>
											Plan
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={
											orderBy === 'product_id.name' ? order : false
										}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'product_id.name'}
											direction={order}
										>
											Costo del producto
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={
											orderBy === 'payment_id.coupon' ? order : false
										}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'payment_id.coupon'}
											direction={order}
										>
											Cupón
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={
											orderBy === 'payment_id.recurrent_interval'
												? order
												: false
										}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'payment_id.recurrent_interval'}
											direction={order}
										>
											Modalidad de pago
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={orderBy === 'comission' ? order : false}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'comission'}
											direction={order}
										>
											Pago por referido
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={
											orderBy === 'paiment_id.payment_date' ? order : false
										}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'paiment_id.payment_date'}
											direction={order}
										>
											Fecha de pago
										</TableSortLabel>
									</TableCell>

									<TableCell
										sortDirection={orderBy === 'status' ? order : false}
										align="left"
									>
										<TableSortLabel
											active={orderBy === 'status'}
											direction={order}
										>
											Status
										</TableSortLabel>
									</TableCell>

									<TableCell align="left">Acciones</TableCell>
								</TableRow>
							</TableHead>
							<TableBody className="table-cells">
								{Array.isArray(customers) &&
									customers.length > 0 &&
									customers.map((customer) => (
										<TableRow key={customer._id}>
											<TableCell>
												{customer.first_name} {customer.last_name}
											</TableCell>
											{/*<TableCell>{customer.email}</TableCell>
                      <TableCell>{customer.kinship}</TableCell>*/}
											<TableCell>
												{customer.product_id ? customer.product_id.name : ''}
											</TableCell>
											<TableCell>
												{customer.product_price
													? `USD. ${Number.parseFloat(
															customer.product_price
													  ).toFixed(2)}`
													: 'USD. 0'}
											</TableCell>
											<TableCell>
												{customer.payment_id && customer.payment_id.coupon
													? 'SI'
													: 'NO'}
											</TableCell>
											<TableCell>
												{customer.payment_id &&
													frecuency(customer.payment_id.recurrent_interval)}
											</TableCell>
											<TableCell>
												{customer.comission
													? `USD. ${Number.parseFloat(
															customer.comission
													  ).toFixed(2)}`
													: customer.comission_pending
													? `USD. ${Number.parseFloat(
															customer.comission_pending
													  ).toFixed(2)}`
													: 'USD. 0'}
											</TableCell>
											<TableCell>
												{customer.payment_id &&
													new Date(
														customer.payment_id.payment_date
													).toLocaleDateString()}
											</TableCell>
											<TableCell>
												{customer.payment_id &&
													statusMessage(customer.payment_id.status)}
											</TableCell>
											<TableCell>
												<div className="flex">
													<Tooltip title="Ver más">
														<IconButton
															key="ver"
															aria-label="ver"
															className="see-more-button"
															onClick={() => showMoreInformation(customer._id)}
														>
															<VisibilityIcon className="text-gray-600" />
														</IconButton>
													</Tooltip>
												</div>
											</TableCell>
										</TableRow>
									))}
							</TableBody>
						</Table>
					</Paper>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default withStyles(styles)(
	withMobileDialog({ breakpoint: 'xs' })(ModalBenefitsList)
);
